// extracted by mini-css-extract-plugin
export var blocks = "styles-module--blocks--2cyaL";